import { useTranslation } from 'react-i18next'

import { z } from '@/lib/zod'

export function ProfilePasswordSchema() {
  const { t } = useTranslation('profile')

  return z
    .object({
      currentPassword: z.string().nonempty(),
      newPassword: z.string().nonempty(),
      confirmNewPassword: z.string().nonempty(),
    })
    .refine((data) => data.newPassword === data.confirmNewPassword, {
      message: t('password.errors.password_mismatch'),
      path: ['confirmNewPassword'],
    })
    .refine((data) => data.currentPassword !== data.newPassword, {
      message: t('password.errors.password_cannot_be_the_same'),
      path: ['newPassword'],
    })
}

export type ProfilePasswordForm = z.infer<
  ReturnType<typeof ProfilePasswordSchema>
>
